export default __webpack_public_path__ + "static/media/personal-1.ae41b62a.png";